/**
 * Parse a free-text goal/expected finishing time into hours.
 * Accepts "3:45", "3:45:00", "4h", "3h30m", "90min", or a bare number (hours).
 * Returns undefined when it can't be parsed. Used to size the long run from the
 * athlete's expected race time.
 */
export function parseGoalHours(s: string | undefined): number | undefined {
  if (!s) return undefined;
  const t = s.trim().toLowerCase();
  const colon = t.match(/^(\d+):(\d{1,2})(?::\d{1,2})?$/);
  if (colon) return parseInt(colon[1], 10) + parseInt(colon[2], 10) / 60;
  const hm = t.match(/^(\d+(?:[.,]\d+)?)\s*h(?:\s*(\d+)\s*m(?:in)?)?$/);
  if (hm) return parseFloat(hm[1].replace(",", ".")) + (hm[2] ? parseInt(hm[2], 10) / 60 : 0);
  const min = t.match(/^(\d+)\s*m(?:in)?$/);
  if (min) return parseInt(min[1], 10) / 60;
  const num = t.match(/^(\d+(?:[.,]\d+)?)$/);
  if (num) return parseFloat(num[1].replace(",", "."));
  return undefined;
}
